import { render, staticRenderFns } from "./DocumentRegister.vue?vue&type=template&id=305498e8&scoped=true&"
import script from "./DocumentRegister.vue?vue&type=script&lang=js&"
export * from "./DocumentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305498e8",
  null
  
)

export default component.exports